import React, { useState, useEffect, useRef, Fragment } from "react";
import { useStore, useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import ScheduleSelector from 'react-schedule-selector'
import { format } from 'date-fns'
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";

// core components
import LandingNavbar from "components/Navbars/LandingNavbar.js";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {
  login,
  getUserAll,
  getUserAllApply,
  getUserProfile,
  deleteUser,
  approveUser,
  getUserAgenda,
  getAgendaOfCounsellor,
  deleteAgenda,
  createAgenda,
  getRoomAll,
  updateRoom,
  removeRoom
} from "../../actions";
import swal from "sweetalert";
import ReactDatatable from "@ashvin27/react-datatable";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getUserDiary } from "actions/adminAction";
import { getUserPractice } from "actions/adminAction";
import { useRadioGroup } from "@material-ui/core";
import { TimerSharp } from "@material-ui/icons";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AddUser from "components/AddUser/IndexAddUser";
import UpdateNoteByCounsellor from "components/UpdateNote/IndexUpdateNoteByCounsellor";
import UpdateNoteBySupervisor from "components/UpdateNote/IndexUpdateNoteBySupervisor";
import UpdateApplyNoteBySupervisor from "components/UpdateNote/IndexUpdateApplyNoteBySupervisor";
import NoteBySupervisor from "components/UpdateNote/IndexNoteBySupervisor";
import RoomEdit from "components/Room/IndexRoomEdit";
import { getUserProfileByUserId } from "actions/adminAction";


function ProfilePage() {
  useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  // useEffect(() => {
  //   document.body.classList.add("login-page");
  //   document.body.classList.add("sidebar-collapse");
  //   document.documentElement.classList.remove("nav-open");
  //   window.scrollTo(0, 0);
  //   document.body.scrollTop = 0;
  //   return function cleanup() {
  //     document.body.classList.remove("login-page");
  //     document.body.classList.remove("sidebar-collapse");
  //   };
  // }, []);

  const {
    adminGetProfile: userProfile,
    adminGetAllUser: allUser,
    adminGetAllUserApply: allUserApply,
    adminGetUserAgenda: userAgenda,
    adminGetAgendaOfCounsellor: agendarCounsellor,
    adminGetUserDiary: userDiary,
    adminGetUserPractice: userPractice,
    adminGetRooms: rooms
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const [token, setToken] = useState(localStorage.getItem("access-token"));
  const [users, setUsers] = useState([]);
  const [usersApply, setUsersApply] = useState([]);
  const [counselors, setCounselors] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [counselorSelected, setCounselorSelected] = useState({});
  const [supervisorSelected, setSupervisorSelected] = useState({});
  const [admin, setAdmin] = useState({});
  const [agenda, setAgenda] = useState([]);
  const [agendaOfCounsellor, setAgendaOfCounsellor] = useState([]);
  const [agendaDateOfCounsellor, setAgendaDateOfCounsellor] = useState([]);
  const [diary, setDiary] = useState([]);
  const [practice, setPractice] = useState([]);
  const [planDate, setPlanDate] = useState(new Date());
  const [counsellingRoom, setCounsellingRoom] = useState([]);
  const [isRoomInit,setIsRoomInit]= useState(false);
  const [newPlan, setNewPlan] = useState({
    gid: 0,
    telephone_no: "",
    plan_date: "",
    plan_time: "",
    plan_datetime: "",
  });
  const [schedule, setSchedule] = useState([])
  const yourDate = new Date()
  const current = moment(yourDate).format("YYYY-MM-DD").toString();
  
  const [isRoomEditModal,setIsRoomEditModal] = useState(false);
  const [selectedRoomForEdit,setSelectedRoomForEdit] = useState({});

  useEffect(() => {
    setToken(localStorage.getItem("access-token"));
  });

  useEffect(() => {
    if (token) {
      dispatch(getUserAll());
      dispatch(getUserAllApply())
      dispatch(getUserProfile());
      dispatch(getRoomAll())
    }
  }, [token]);



  useEffect(() => {
    if (userAgenda.data && !userAgenda.isLoading && !userAgenda.isFailed) {
      var agendarList = userAgenda.data;
      if(admin){
        for (let index = 0; index < agendarList.length; index++) {
          agendarList[index].isEnableSupervisorNote= admin.person_type==2 || admin.person_type==4 ;
        }
      }
      setAgenda(agendarList);
    }
  }, [userAgenda]);

  useEffect(() => {
    if (agendarCounsellor.data && !agendarCounsellor.isLoading && !agendarCounsellor.isFailed) {
      setAgendaOfCounsellor(agendarCounsellor.data);
      var schedules = [];
      agendarCounsellor.data.forEach(element => {
        var strDate =  element.plan_date +' '+  element.plan_time.substring(0, 2) +':00';;
        var date = new Date(strDate)
        schedules.push(date);
      })
    
     setAgendaDateOfCounsellor(schedules)
    }
  }, [agendarCounsellor]);

  useEffect(() => {
    if(rooms.data && !rooms.isLoading && !rooms.isFailed){
      setCounsellingRoom(rooms.data)
    }
  }, [rooms])

  const [usersColumn, setUsersColumn] = useState([
    {
      key: "uNumber",
      text: "เลขที่",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        /*return <span>{record.uNumber}</span>;*/
        return  <Fragment>
        <button
          className="btn btn-info btn-sm btn-round btn-icon"
          onClick={() => handleViewUserProfile(record)}
          style={{ marginRight: "10px" }}
        >
          {record.uNumber}
        </button>
      
      </Fragment>;
      },
    },
    {
      key: "telephoneNo",
      text: "หมายเลขโทรศัพท์",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        var numl = record.telephoneNo.slice(0,3);
        var numr = record.telephoneNo.slice(7,10);
        var num = numl + '*****'+ numr;
        return <span>{num}</span>;
      },
    },
    {
      key: "userName",
      text: "ชื่อผู้รับการปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        return <span>{record.userName}</span>;
      },
    },
    {
      key: "nextappointment",
      text: "วันเวลานัดหมาย",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        if(record.nextappointment!='0001-01-01T00:00:00'){
          return <span>{record.nextappointment.replace('T',' ')}</span>;
        }else{
          return <span>ไม่พบการนัดหมาย</span>;
        }
        
      },
    },
    {
      key: "appointment",
      text: "นัดหมาย",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => {
        var v = record.nextappointment.split('T');
       
        if(current==v[0]){
          return (
            <Fragment>    
             

              <Button
                    className="btn btn-info btn-sm btn-round btn-icon"
                    style={{ marginRight: "10px" }}
                    href={`https://meet.jit.si/${record.telephoneNo}`}
                    target="_blank"
                  >
                     <i className="far fa-comments"></i>
                  </Button>


              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleEditRecord(record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
             
            </Fragment>
          );
        }else{
          return (
            <Fragment>           
              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleEditRecord(record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
             
            </Fragment>
          );
        }
        
      },
    },
    {
      key: "counsellor_full_name",
      text: "ผู้ให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
              {
              record.counsellor_full_name
              }
          </Fragment>
        );
      },
    },
    {
      key: "supervisor_full_name",
      text: "อาจารย์ผู้ให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
              {
              record.supervisor_full_name
              }
          </Fragment>
        );
      },
    },
    {
      key: "view_manage",
      text: "มุมฝึกคิด",
      className: "text-center",
      align: "center",
      width: 50,
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>

            <button
              className="btn btn-warning btn-sm btn-round btn-icon"
              onClick={() => handleEditDiaryRecord(record)}
              style={{ marginRight: "10px" }}
            >
              <i className="fa fa-calendar"></i>
            </button>


            <button
              className="btn btn-warning btn-sm btn-round btn-icon"
              onClick={() => handleEditPracticeRecord(record)}
              style={{ marginRight: "10px" }}
            >
               <i className="far fa-comments"></i>
            </button>
          
          </Fragment>
        );
      },
    },
    
    {
      key: "isApprove",
      text: "อนุมัติใช้งาน",
      className: "text-center",
      align: "center",
      width: 50,
      sortable: false,
      cell: (record) => {
        return (
          <span>
            <Switch
              onChange={() => handleApprove(record)}
              checked={record.isApprove}
            />
          </span>
        );
      },
    },
    {
      key: "action",
      text: "ลบผู้ใช้",
      className: "td-action text-center",
      width: 50,
      align: "center",
      sortable: false,
      
      cell: (record) => {
        return (

          <Fragment>
           
            <button
              className="btn btn-danger btn-sm btn-round btn-icon"
              onClick={() => handleDeleteRecord(record)}
            >
              <i className="fa fa-trash"></i>
            </button>
          
          </Fragment>
        );
      },
      
    },
    
    
  ]);

  const [usersApplyColumn, setUsersApplyColumn] = useState([
    {
      key: "uNumber",
      text: "เลขที่",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        /*return <span>{record.uNumber}</span>;*/
        return  <Fragment>
        <button
          className="btn btn-info btn-sm btn-round btn-icon"
          onClick={() => handleViewUserProfile(record)}
          style={{ marginRight: "10px" }}
        >
          {record.uNumber}
        </button>
      
      </Fragment>;
      },
    },
    {
      key: "telephoneNo",
      text: "หมายเลขโทรศัพท์",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        return <span>{record.telephoneNo}</span>;
      },
    },
    {
      key: "apply_date",
      text: "วันที่ลงทะเบียน",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return <span>{record.apply_date.replace('T',' ')}</span>;
      },
    },
    // {
    //   key: "stressScore",
    //   text: "คะแนนความเครียด",
    //   className: "text-center",
    //   align: "center",
    //   sortable: true,
    //   cell: (record) => {
    //     return <span>{record.stressScore}</span>;
    //   },
    // },
    {
      key: "userApplyDetail",
      text: "รายละเอียดผู้ลงทะเบียน",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-info btn-sm btn-round btn-icon"
              onClick={() => handleViewUserApply(record)}
              style={{ marginRight: "10px" }}
            >
              <i className="fa fa-eye"></i>
            </button>
          
          </Fragment>
        );
      },
    },
    {
      key: "supervisor_note",
      text: "Progress note",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => {
        
      
          return (
            <Fragment>    

              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleUpdateApplyNoteBySupervisor(record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
             
            </Fragment>
          );
       
        
      },
    },
    {
      key: "isApprove",
      text: "อนุมัติใช้งาน",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <span>
            <Switch
              onChange={() => handleApprove(record)}
              checked={record.isApprove}
            />
          </span>
        );
      },
    },
    {
      key: "action",
      text: "ลบผู้ใช้งาน",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      
      cell: (record) => {
        return (

          <Fragment>
           
            <button
              className="btn btn-danger btn-sm btn-round btn-icon"
              onClick={() => handleDeleteRecord(record)}
            >
              <i className="fa fa-trash"></i>
            </button>
          
          </Fragment>
        );
      },
      
    },
    
    
  ]);

  const [counselorsColumn, setCounselorsColumn] = useState([
    {
      key: "telephoneNo",
      text: "หมายเลขโทรศัพท์",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return <span>{record.telephoneNo}</span>;
      },
    },
    {
      key: "userName",
      text: "ชื่อ-สกุล",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return <span>{record.userName}</span>;
      },
    },
    {
      key: "nextappointment",
      text: "นัดหมายที่กำลังจะมาถึง",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        if(record.nextappointment!='0001-01-01T00:00:00'){
          return <span>{record.nextappointment.replace('T',' ')}</span>;
        }else{
          return <span>ไม่พบการนัดหมาย</span>;
        }
        
      },
    },
   
    {
      key: "isApprove",
      text: "อนุมัติใช้งาน",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <span>
            <Switch
              onChange={() => handleApprove(record)}
              checked={record.isApprove}
            />
          </span>
        );
      },
    },
    {
      key: "action",
      text: "ลบผู้ใช้งาน",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      
      cell: (record) => {
        return (
          <Fragment>
           
            <button
              className="btn btn-danger btn-sm btn-round btn-icon"
              onClick={() => handleDeleteRecord(record)}
            >
              <i className="fa fa-trash"></i>
            </button>
            
          </Fragment>
        );
      },
      
    },
    
    
  ]);
  const [usersApplyConfig, setUsersApplyConfig] = useState({
    key_column: "telephoneNo",
    page_size: 10,
    length_menu: [5, 10, 15, 20],
    filename: "รายการผู้รับบริการ",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดงผู้ลงทะเบียนที่ยังไม่ทำการนัดหมาย _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
  });
  const [usersConfig, setUsersConfig] = useState({
    key_column: "telephoneNo",
    page_size: 10,
    length_menu: [5, 10, 15, 20],
    filename: "รายการผู้รับบริการ",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
  });
  const [usersButtons, setUsersButtons] = useState([
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ]);
  const [agendaColumn, setAgendaColumn] = useState([
    {
      key: "telephone_no",
      text: "หมายเลขโทรศัพท์",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        var numl = record.telephone_no.slice(0,3);
        var numr = record.telephone_no.slice(7,10);
        var num = numl + '*****'+ numr;
        return <span>{num}</span>;
      },
    },
    {
      key: "plan_date",
      text: "วันที่นัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "plan_time",
      text: "เวลานัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "counsellor_full_name",
      text: "ผู้ให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "supervisor_full_name",
      text: "อาจารย์ผู้ให้การปรึกษา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "note",
      text: "สรุปการปรึกษา",
      className: "td-action text-center",
      width: 50,
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {/* <button
              className="btn btn-info btn-sm btn-round btn-icon"
              onClick={() => handleCallNow(record)}
              style={{ marginRight: "10px" }}
            >
              <i className="fa fa-edit"></i>
            </button> */}
            <button
              className="btn btn-info btn-sm btn-round btn-icon"
              onClick={() => handleUpdateNoteByCounsellor(record)}
            >
              <i className="fa fa-edit"></i>
            </button>
          </Fragment>
        );
      },
    },
    {
      key: "isSupervisorFeedback",
      text: "อาจารย์นิเทศ",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>

            { record.supervisor_note &&
              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleNoteBySupervisor(record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-eye"></i>
              </button>
            }
           {record.isEnableSupervisorNote}
            {
              record.isEnableSupervisorNote &&
              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleUpdateNoteBySupervisor(record)}
                >
                <i className="fa fa-edit"></i>
              </button>
            }
          </Fragment>
        );
      },
    },
    {
      key: "action",
      text: "ลบนัดหมาย",
      className: "td-action text-center",
      width: 150,
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            {/* <button
              className="btn btn-info btn-sm btn-round btn-icon"
              onClick={() => handleCallNow(record)}
              style={{ marginRight: "10px" }}
            >
              <i className="fa fa-edit"></i>
            </button> */}
            <button
              className="btn btn-danger btn-sm btn-round btn-icon"
              onClick={() => handleDeleteAgenda(record)}
            >
              <i className="fa fa-trash"></i>
            </button>
          </Fragment>
        );
      },
    },
  ]);
  const [agendaConfig, setAgendaConfig] = useState({
    key_column: "gid",
    page_size: 10,
    length_menu: [5, 10, 15, 20],
    filename: "รายการนัดหมาย",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });
  const [agendaButtons, setAgendaButtons] = useState([
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"
          ></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ]);



  const [diaryColumn, setDiaryColumn] = useState([
    {
      key: "diary_date",
      text: "วันที่",
      className: "text-center",
      align: "center",
      sortable: true,
      width: 110,
      cell: (record) => {
       
          return <span>{record.diary_date.replace('T',' ')}</span>;
       
      },
    },
   
    {
      key: "message_detail",
      text: "บันทึกประจำวันนี้",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "emotional_type",
      text: "ระดับความเครียด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },


    {
      key: "event_detail",
      text: "เหตุการณ์ที่ทำให้เกิดอารมณ์/ความเครียด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "idea_detail",
      text: "ความคิด/ความเชื่อต่อเหตุการณ์",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "feeling_detail",
      text: "สิ่งที่มีผลตามมา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "dispute",
      text: "ทางเลือกอื่นๆ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
  ]);
  const [diaryConfig, setDiaryConfig] = useState({
    key_column: "gid",
    page_size: 5,
    length_menu: [5, 10, 15, 20],
    filename: "รายการไดอารี่",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });
  const [practiceColumn, setPracticeColumn] = useState([
   
    {
      key: "created_date",
      text: "เพิ่มเมื่อ",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
          return <span>{record.created_date.replace('T',' ')}</span>;
       
      },
    },
   
    {
      key: "activating_event",
      text: "เหตุการณ์",
      className: "text-left",
      align: "left",
      sortable: true,
      
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "belief_thought",
      text: "ความคิด/ความเชื่อ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    {
      key: "consequence_feelings",
      text: "ผลที่ตามมา",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "dispute",
      text: "ทางเลือกอื่นๆ",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    
    
  ]);
  const [practiceConfig, setPracticeConfig] = useState({
    key_column: "gid",
    page_size: 5,
    length_menu: [5, 10, 15, 20],
    filename: "รายการฝึกคิด",
    no_data_text: "ไม่พบข้อมูล!",
    button: {
      excel: false,
      print: false,
      csv: false,
      extra: false,
    },
    language: {
      length_menu: "แสดง _MENU_ รายการ/หน้า",
      filter: "ค้นหาข้อมูลในรายการ...",
      info: "แสดง _START_ ถึง _END_ ของทั้งหมด _TOTAL_ รายการ",
      pagination: {
        first: "First",
        previous: <span>&#9668;</span>,
        next: <span>&#9658;</span>,
        last: "Last",
      },
    },
    pagination: "advance", //advance
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: true,
  });

  const [agendaCounsellorColumn, setAgendaCounsellorColumn] = useState([

    {
      key: "plan_date",
      text: "วันที่นัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_date}</span>;
      // },
    },
    {
      key: "plan_time",
      text: "เวลานัด",
      className: "text-center",
      align: "center",
      sortable: true,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "counsellee_full_name",
      text: "ผู้รับการปรึกษา",
      className: "text-center",
      align: "center",
      sortable: false,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "telephone_no",
      text: "หมายเลขโทรศัพท์",
      className: "text-center",
      align: "center",
      sortable: false,
      // cell: (record) => {
      //   return <span>{record.plan_time}</span>;
      // },
    },
    {
      key: "counselling_room",
      text: "ห้องการปรึกษา",
      className: "text-center",
      align: "center",
      cell:( record) =>{
        var v = record.plan_datetime.split('T');
        if(current==v[0]){
          return  ( 
          <Fragment>
              <Button
                className="btn-round"
                color="info"
                href={`https://meet.jit.si/${record.telephone_no}`}
                target="_blank"
              >
                เข้าห้องการปรึกษา
              </Button>
          </Fragment>)
        }else{
          return (<span></span>)
        }
      }
    }
    
  ]);

  const [roomColumn, setroomColumn] = useState([
    {
      key: "room_code",
      text: "รหัสห้อง",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return  ( 
          <Fragment>
              <Button
                className="btn-round"
                color="info"
                href={`https://meet.jit.si/${record.room_code}`}
                target="_blank"
              >
                {record.room_code}
              </Button>
          </Fragment>)
      },
    },
    {
      key: "room_name",
      text: "ชื่อห้อง",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return  ( 
          <Fragment>
              <Button
                className="btn-round"
                color="info"
                href={`https://meet.jit.si/${record.room_code}`}
                target="_blank"
              >
                {record.room_name}
              </Button>
          </Fragment>)
      },
    },
    {
      key: "counsellor_full_name",
      text: "นักจิตวิทยา/นักศึกษาจิตวิทยา/ผู้ให้บริการ",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
       
        return <span>{record.counsellor_full_name}</span>;
      },
    },
    {
      key: "supervisor_full_name",
      text: "อาจารย์/ผู้นิเทศ/ผู้รับผิดชอบ",
      className: "text-center",
      align: "center",
      sortable: true,
      cell: (record) => {
        return <span>{record.supervisor_full_name}</span>;
      },
    },
    {
      key: "isMasterRoom",
      text: "ห้อง Walk-in",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <span>
            <Switch
              onChange={() => handleMasterRoom(record)}
              checked={record.is_master_room}
            />
          </span>
        );
      },
    },
   
    {
      key: "isOpen",
      text: "เปิด/ปิดห้อง",
      className: "text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <span>
            <Switch
              onChange={() => handleOpenRoom(record)}
              checked={record.is_open}
            />
          </span>
        );
      },
    },
    {
      key: "manageroom",
      text: "จัดการ",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => {

          return (
            <Fragment>

              <button
                className="btn btn-info btn-sm btn-round btn-icon"
                onClick={() => handleEditRoom(record)}
                style={{ marginRight: "10px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
             
            </Fragment>
          );
        
        
      },
    },
    {
      key: "action",
      text: "ลบห้อง",
      className: "td-action text-center",
      width: 100,
      align: "center",
      sortable: false,
      
      cell: (record) => {
        return (

          <Fragment>
           
            <button
              className="btn btn-danger btn-sm btn-round btn-icon"
              onClick={() => handleDeleteRoom(record)}
            >
              <i className="fa fa-trash"></i>
            </button>
          
          </Fragment>
        );
      },
      
    },

    
    
  ]);

  const [isEdit, setIsEdit] = useState(false);
  const [isEditDiary, setIsEditDiary] = useState(false);
  const [isEditPractice,setIsEditPractice] = useState(false);
  const [isAddUserModal,setIsAddUserModal] = useState(false);
  const [userType,setUserType] = useState(false);
  const [isUpdateNoteCounsellorModal,setIsUpdateNoteCounsellorModal] = useState(false);
  const [noteCounsellorModal,setNoteCounsellorModal] = useState({});
  const [isUpdateNoteSupervisorModal,setIsUpdateNoteSupervisorModal] = useState(false);
  const [noteSupervisorModal,setNoteSupervisorModal] = useState({});
  const [isNoteSupervisorModal,setIsNoteSupervisorModal] = useState(false);
  const [isUpdateApplyNoteSupervisorModal,setIsUpdateApplyNoteSupervisorModal] = useState(false);
  const [applyNoteSupervisorModal,setApplyNoteSupervisorModal] = useState({});
  const [isApplyNoteSupervisorModal,setIsApplyNoteSupervisorModal] = useState(false);
  const [selectUser, setSelectUser] = useState({});
  const [selectUserApply, setSelectUserApply] = useState({});
  const [isUserApplyModal,setUserApplyModal] = useState(false);


  const handleMasterRoom = (data) => {
    if(data.is_master_room){
      data.is_master_room=false;
    }else{
      data.is_master_room=true;
    }
    updateRoom(data).then((res) => {
      if (res) {
        dispatch(getRoomAll());
      }
    });
  };
  const handleOpenRoom = (data) => {
    if(data.is_open){
      data.is_open=false;
    }else{
      data.is_open=true;
    }
    updateRoom(data).then((res) => {
      if (res) {
        dispatch(getRoomAll());
      }
    });
  };
  const handleDeleteRoom = (data) => {
    removeRoom(data).then((res) => {
      if (res) {
        dispatch(getRoomAll());
      }
    });
  };
  const handleEditRoom = (data) => {
    setIsRoomInit(false);
    setSelectedRoomForEdit(data);
    setIsRoomEditModal(true);
  };

  const _OnRoomEditChanged = () => {
    dispatch(getRoomAll());
    setIsRoomEditModal(false);
  }
  const handleApprove = (data) => {
    approveUser(data.uid, !data.isApprove).then((res) => {
      if (res) {
        dispatch(getUserAll());
        dispatch(getUserAllApply());
      }
    });
  };

  const handleEditRecord = (record) => {
    setSelectUser(record);
    dispatch(getUserAgenda(record.telephoneNo)).then((res) => {
      setNewPlan({ ...newPlan, telephone_no: record.telephoneNo });
      setPlanDate(new Date());
      setIsEdit(true);
    });
  };

const handleViewUserApply = (profile) => {
  var obj = profile.userProfile
  setSelectUserApply(obj);
  setUserApplyModal(true);
}

const handleViewUserProfile = (record) => {
  setUserApplyModal(true);
  dispatch(getUserProfileByUserId(record.uid)).then((res) => {
    setSelectUserApply(res.data);
    
  });
}

  const handleEditDiaryRecord = (record) => {
    setSelectUser(record);
    dispatch(getUserDiary(record.telephoneNo)).then((res) => {
 
      setIsEditDiary(true);
    });
  };

  const handleEditPracticeRecord = (record) => {
    setSelectUser(record);
    dispatch(getUserPractice(record.telephoneNo)).then((res) => {
 
      setIsEditPractice(true);
    });
  };

  const handleDeleteRecord = (record) => {
    swal({
      title: `คุณแน่ใจที่จะลบผู้รับบริการ ${record.telephoneNo} ?`,
      text: "ข้อมูลเกี่ยวกับผู้รับบริการจะถูกลบทั้งหมด!",
      icon: "warning",
      buttons: ["ยกลิก", "ตกลง"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteUser(record.uid).then((res) => {
          if (res) {
            swal("ผู้รับบริการถูกลบแล้ว!", {
              icon: "success",
              buttons: "ตกลง",
            });
            dispatch(getUserAll());
            dispatch(getUserAllApply());
          }
        });
      } else {
      }
    });
  };

  const handleUpdateNoteByCounsellor = (record) => {
    setIsEdit(false);
    setIsUpdateNoteCounsellorModal(true);
    setNoteCounsellorModal(record);
  };

  const handleUpdateNoteBySupervisor = (record) => {
    setIsEdit(false);
    setIsUpdateNoteSupervisorModal(true);
    setNoteSupervisorModal(record);
  };

  const handleUpdateApplyNoteBySupervisor = (record) => {
    setIsEdit(false);
    setIsUpdateApplyNoteSupervisorModal(true);
    setApplyNoteSupervisorModal(record);
  };
  
  const handleNoteBySupervisor= (record) => {
    setIsEdit(false);
    setIsNoteSupervisorModal(true);
    setNoteSupervisorModal(record);
  };

  const handleDeleteAgenda = (record) => {
    swal({
      title: `คุณแน่ใจที่จะลบนัดหมาย ${record.plan_date} เวลา ${record.plan_time} น. ?`,
      text: "คุณสามารถสร้างใหม่ได้ภายหลัง!",
      icon: "warning",
      buttons: ["ยกลิก", "ตกลง"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteAgenda(record.gid).then((res) => {
          if (res) {
            swal("การนัดหมายถูกลบแล้ว!", {
              icon: "success",
              buttons: "ตกลง",
            });
            dispatch(getUserAgenda(record.telephone_no));
            dispatch(getUserAll());
          }
        });
      } else {
      }
    });
  };

  useEffect(() => {
   
    if (allUser.data && !allUser.isLoading && !allUser.isFailed) {
      setUsers(allUser.data.filter(counselor => {
        return counselor.userType === 1 ||  counselor.userType === 3;
      }));
      setCounselors(allUser.data.filter(counselor => {
        // case 3: Counsellor;  
        // case 4: Supervisor; 
        return counselor.userType === 3 || counselor.userType === 4;
      }));
      
      setSupervisors(allUser.data.filter(counselor => {
        return counselor.userType === 4;
      }));
    }

    
  }, [allUser]);

  useEffect(() => {
    
    if(allUserApply){
      if (allUserApply.data && !allUserApply.isLoading && !allUserApply.isFailed) {
        setUsersApply(allUserApply.data);
      }
    }
   
    
  }, [allUserApply]);

  useEffect(() => {
    if(selectUserApply)
    if(selectUserApply.counselling_schedule){
      var obj = JSON.parse(selectUserApply.counselling_schedule)
      setSchedule(obj)
    }
  },[selectUserApply])

  useEffect(() => {
    
    if (userProfile.data && !userProfile.isLoading && !userProfile.isFailed) {
      setAdmin(userProfile.data);
      if(userProfile.data.uid)  dispatch(getAgendaOfCounsellor(userProfile.data.uid))
    }
  }, [userProfile]);


  useEffect(() => {
    if (userAgenda.data && !userAgenda.isLoading && !userAgenda.isFailed) {
      setAgenda(userAgenda.data);
    }
  }, [userAgenda]);

  useEffect(() => {
    if (userDiary.data && !userDiary.isLoading && !userDiary.isFailed) {
      setDiary(userDiary.data);
    }
  }, [userDiary]);

  useEffect(() => {
    if (userPractice.data && !userPractice.isLoading && !userPractice.isFailed) {
      setPractice(userPractice.data);
    }
  }, [userPractice]);

  const _onLogout = async () => {
    await localStorage.clear();
    await setToken(localStorage.getItem("access-token"));
  };

  

  useEffect(() => {
    setNewPlan({
      ...newPlan,
      plan_date: moment(planDate).format("YYYY-MM-DD").toString(),
      plan_time: moment(planDate).format("HH:mm").toString(),
      plan_datetime: moment(planDate).format("YYYY-MM-DDTHH:mm:ss"),
      counsellor_uid: counselorSelected?counselorSelected.uid:'',
      supervisor_uid: supervisorSelected?supervisorSelected.uid:'',

    });
  }, [planDate,counselorSelected,supervisorSelected]);

  const handleCreateAgenda = () => {
    createAgenda(newPlan).then((res) => {
      swal("เพิ่มรายการสำเร็จ!", {
        icon: "success",
        buttons: "ตกลง",
      });
      dispatch(getUserAgenda(selectUser.telephoneNo));
      dispatch(getUserAll());
    });
  };

  const _onAddUserSuccess = (result) => {
    if (result) {
      setIsAddUserModal(false)
      setUserType(0)
      swal({
        title: "เพิ่มสมาชิกสำเร็จ!",
        text: "เพิ่มสมาชิกสำเร็จ",
        icon: "success",
        button: "ตกลง",
      })
      dispatch(getUserAll());
    }
  }
  const _onCloseNoteByConsellor = () =>{
    setIsUpdateNoteCounsellorModal(false);
    setIsEdit(true);
  }
  const _onCloseNoteBySupervisor = () =>{
    setIsUpdateNoteSupervisorModal(false);
    setIsNoteSupervisorModal(false);
    setIsEdit(true);
  }
  const _onUpdateNoteByConsellorSuccess = (result) => {
    console.log(result);
    if (result) {
      setIsUpdateNoteCounsellorModal(false)
      
      swal({
        title: "บันทึกการให้การปรึกษา!",
        text: "บันทึกการให้การปรึกษาสำเร็จ",
        icon: "success",
        button: "ตกลง",
      })
      dispatch(getUserAgenda(selectUser.telephoneNo));
      setIsEdit(true)
    }
  }

  const _onUpdateNoteBySupervisorSuccess = (result) => {
    if (result) {
      setIsUpdateNoteSupervisorModal(false)
      swal({
        title: "บันทึก Feedback การให้การปรึกษา!",
        text: "บันทึก  Feedback การให้การปรึกษาสำเร็จ",
        icon: "success",
        button: "ตกลง",
      })
      dispatch(getUserAgenda(selectUser.telephoneNo));
      dispatch(getUserAll());
    }
  }

  const _onCloseApplyNoteBySupervisor = () =>{
    setIsUpdateApplyNoteSupervisorModal(false);
    setIsApplyNoteSupervisorModal(false);
    
  }

  const _onUpdateApplyNoteBySupervisorSuccess = (result) => {
    if (result) {
      setIsUpdateApplyNoteSupervisorModal(false)
      swal({
        title: "บันทึก Progress note!",
        text: "บันทึก  Progress note สำเร็จ",
        icon: "success",
        button: "ตกลง",
      })
      dispatch(getUserAllApply());
    }
  }
  
  
  

  return (
    <>
      <LandingNavbar
        token={token}
        logout={() => _onLogout()}
        onPage="profile"
        isAdmin={true}
      />
      <div className="wrapper">
      
        <ProfilePageHeader numberOfMember={users.length} profile={admin} isLoadingProfile={userProfile.isLoading} />

        <div className="section">
         
          <Container>
            
          <Tabs
                  defaultActiveKey="agendarcounsellor"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                >
                  {admin.person_type!=2 &&
                   <Tab eventKey="agendarcounsellor" title="นัดหมายของฉัน" show={true}>
                   
                      <ScheduleSelector
                          selection={agendaDateOfCounsellor}
                          startDate={moment().format('YYYY-MM-DD')}
                          selectionScheme="linear"
                          numDays={31}
                          minTime={8}
                          maxTime={17}
                          hourlyChunks={1}
                          renderDateLabel={(date) =>{
                            var str = '';
                            if(format(date,'yyyy-MM-dd')==moment().format('YYYY-MM-DD')){
                              str = format(date,'MMM d')
                             
                            }
                            else if(format(date,'d')==1){
                             
                              str = format(date,'MMM d')
                             }
                            else{
                               str = format(date,'___ d')
                            }
                            if(format(date,'EEEEE')=='S'){
                              return <span style={{color:'red'}}>{str}</span>
                            }else{
                              return <span>{str}</span>
                            }
                            
                          }}
                        
                      
                    />
                      <ReactDatatable
                          config={agendaConfig}
                          records={agendaOfCounsellor}
                          columns={agendaCounsellorColumn}
                          usersButtons={agendaButtons}
                          loading={agendarCounsellor.isLoading}
                        />
                   
                    </Tab>
                  }
                  <Tab eventKey="counselee" title="ผู้รับการปรึกษา">
                      
                      <ReactDatatable
                        config={usersConfig}
                        records={users}
                        columns={usersColumn}
                        usersButtons={usersButtons}
                        loading={allUser.isLoading}
                        
                       
                      />
                   
                  </Tab>
                  {admin.person_type!=3 &&
                    <Tab eventKey="application" title="ผู้ลงทะเบียนขอรับการปรึกษา" disabled={admin.person_type==3} hidden={admin.person_type==3}>
                        
                        <ReactDatatable
                          config={usersApplyConfig}
                          records={usersApply}
                          columns={usersApplyColumn}
                          usersButtons={usersButtons}
                          loading={allUserApply?allUserApply.isLoading:false}
                          
                        
                        />
                    
                    </Tab>
                    }
                   {admin.person_type!=3 &&
                  <Tab eventKey="counsellor" title="ผู้ให้การปรึกษา" disabled={admin.person_type==3} hidden={admin.person_type==3}>
                  

                    <Button
                      className="btn-round"
                      color="success"
                      onClick={() => {setIsAddUserModal(true); setUserType(3);}}
                    >
                      เพิ่มผู้ให้การปรึกษา
                    </Button>


                    <ReactDatatable
                          config={usersConfig}
                          records={counselors}
                          columns={counselorsColumn}
                          usersButtons={usersButtons}
                          loading={allUser.isLoading}
                        />
                    
                  </Tab>
                    }
                    {admin.person_type!=3 &&
                  <Tab eventKey="supervisor" title="อาจารย์ผู้ให้การปรึกษา" disabled={admin.person_type==3 || admin.person_type==4} hidden={admin.person_type==3 || admin.person_type==4}>
                    
                    <Button
                      className="btn-round"
                      color="success"
                      onClick={() => {setIsAddUserModal(true); setUserType(4);}}
                    >
                      เพิ่มอาจารย์ผู้ให้การปรึกษา
                    </Button>
                    <ReactDatatable
                            config={usersConfig}
                            records={supervisors}
                            columns={counselorsColumn}
                            usersButtons={usersButtons}
                            loading={allUser.isLoading}
                          />
                  </Tab>
                  }
                  <Tab eventKey="counselling_room" title="ห้องให้การปรึกษา/Walk-in">
                
                   {admin.person_type!=3 &&
                      <Button
                        className="btn-round"
                        color="success"
                        onClick={() => {setIsRoomInit(true); setIsRoomEditModal(true);}}
                      >
                        เพิ่มห้องให้การปรึกษา
                      </Button>
                    }
                      <ReactDatatable
                        config={usersConfig}
                        records={counsellingRoom}
                        columns={roomColumn}
                        usersButtons={usersButtons}
                        loading={rooms.isLoading}
                        
                       
                      />
                   
                  </Tab>
          </Tabs>

           
            <Row></Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
      <Modal
        isOpen={isEdit}
        className="modal-xl"
        modalClassName="bd-example-modal-xl"
      >
        <div className="modal-header justify-content-center">
          <button
            className="close"
            type="button"
            onClick={() => setIsEdit(false)}
          >
            <i className="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <h3 className="title title-up">จัดการนัดหมาย</h3>
        </div>
        <ModalBody>
          <Card style={{ width: "100%" }}>
            <CardBody>
              <Row>
                <Col>
                    <Button
                      className="btn-round"
                      color="info"
                      href={`https://meet.jit.si/${selectUser.telephoneNo}`}
                      target="_blank"
                    >
                      เข้าห้องการปรึกษา
                    </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card style={{ width: "100%" }}>
            <CardBody>
              <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                เพิ่มรายการนัดหมาย
              </CardTitle>
             
              <Row>
                <Col>
                วันเวลาที่นัด
                </Col>
                <Col>
                  <DatePicker
                    selected={planDate}
                    onChange={(date) => setPlanDate(date)}
                    timeInputLabel="เวลา: "
                    dateFormat="yyyy-MM-dd hh:mm aa"
                    showTimeInput
                  />
                 
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row>
                <Col>
                    ผู้ให้การปรึกษา
                </Col>
                <Col>
                  <Select value={counselorSelected}  options={counselors} onChange={(event) => setCounselorSelected(event)} />
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row>
                <Col>
                  อาจารย์ผู้ให้การปรึกษา
                </Col>
                <Col>
                  <Select value={supervisorSelected} options={supervisors} onChange={(event) => setSupervisorSelected(event)} />
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row>
                <Col>
                </Col>
                <Col>
                  <Button
                      className="btn-round"
                      color="success"
                      onClick={() => handleCreateAgenda()}
                    >
                      เพิ่มนัดหมาย
                    </Button>
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>
            </CardBody>
          </Card>
          <Card style={{ width: "100%" }}>
            <CardBody>
              <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                รายการนัดหมาย
              </CardTitle>
              <ReactDatatable
                config={agendaConfig}
                records={agenda}
                columns={agendaColumn}
                usersButtons={agendaButtons}
                loading={userAgenda.isLoading}
              />
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isEditDiary}
        className="modal-xl"
        modalClassName="bd-example-modal-xl"
        style={{maxWidth: 1240 + 'px'}} 
      >
        <div className="modal-header justify-content-center">
          <button
            className="close"
            type="button"
            onClick={() => setIsEditDiary(false)}
          >
            <i className="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <h3 className="title title-up">ไดอารี่</h3>
        </div>
        <ModalBody>
          
          <Card style={{ width: "100%" }}>
            <CardBody>
              <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                รายการไดอารี่
              </CardTitle>
              <ReactDatatable
                config={diaryConfig}
                records={diary}
                columns={diaryColumn}
                usersButtons={null}
                loading={userDiary.isLoading}
              />
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>


      <Modal
        isOpen={isEditPractice}
        className="modal-xl"
        modalClassName="bd-example-modal-xl"
        style={{maxWidth: 1240 + 'px'}} 
      >
        <div className="modal-header justify-content-center">
          <button
            className="close"
            type="button"
            onClick={() => setIsEditPractice(false)}
          >
            <i className="now-ui-icons ui-1_simple-remove"></i>
          </button>
          <h3 className="title title-up">มุมฝึกคิด</h3>
        </div>
        <ModalBody>
          
          <Card style={{ width: "100%" }}>
            <CardBody>
              <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                รายการฝึกคิด
              </CardTitle>
              <ReactDatatable
                config={practiceConfig}
                records={practice}
                columns={practiceColumn}
                usersButtons={null}
                loading={userPractice.isLoading}
              />
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>

      <Modal
          isOpen={isAddUserModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() => setIsAddUserModal(false)}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">เพิ่มผู้ใช้งาน</h3>
          </div>
          <ModalBody>
            <AddUser
              userType={userType}
              token={token}
              onSuccess={(result) => _onAddUserSuccess(result)}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isUpdateNoteCounsellorModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() =>  _onCloseNoteByConsellor()}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">บันทึกการให้การปรึกษา</h3>
          </div>
          <ModalBody>
            <UpdateNoteByCounsellor
              token={token}
              item={noteCounsellorModal}
              onSuccess={(result) => _onUpdateNoteByConsellorSuccess(result)}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isUpdateNoteSupervisorModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() =>  _onCloseNoteBySupervisor()}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">บันทึก Feedback การให้การปรึกษา</h3>
          </div>
          <ModalBody>
            <UpdateNoteBySupervisor
              token={token}
              item={noteSupervisorModal}
              onSuccess={(result) => _onUpdateNoteBySupervisorSuccess(result)}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isUpdateApplyNoteSupervisorModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() =>  _onCloseApplyNoteBySupervisor()}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">บันทึก Progress note</h3>
          </div>
          <ModalBody>
            <UpdateApplyNoteBySupervisor
              token={token}
              item={applyNoteSupervisorModal}
              onSuccess={(result) => _onUpdateApplyNoteBySupervisorSuccess(result)}
            />
          </ModalBody>
        </Modal>


        <Modal
          isOpen={isNoteSupervisorModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() =>  _onCloseNoteBySupervisor()}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">Feedback การให้การปรึกษา</h3>
          </div>
          <ModalBody>
            <NoteBySupervisor
              token={token}
              item={noteSupervisorModal}
              
            />
          </ModalBody>
        </Modal>


        <Modal
          isOpen={isUserApplyModal}
          className="modal-lx"
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() =>  setUserApplyModal(false)}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">ข้อมูลผู้ลงทะเบียนขอรับการปรึกษา</h3>
          </div>
          <ModalBody>
            <Card style={{ width: "100%" }}>
              <CardBody>
 
                <Row> <Col> ชื่อ-สกุล </Col>   <Col>  {`${selectUserApply.person_first_name} ${selectUserApply.person_last_name}`} </Col>   </Row>
                <Row> <Col> อายุ </Col>   <Col>  {selectUserApply.ageNumber} </Col>    </Row>
                <Row> <Col> อีเมล </Col>   <Col>  {selectUserApply.email} </Col>    </Row>
                <Row>  <Col> หมายเลขโทรศัพท์ </Col>   <Col>  {selectUserApply.telephone_no1} </Col>   </Row>
                <Row>  <Col> ประเภทของผู้รับบริการ </Col>   
                        <Col> 
                            {selectUserApply.user_type_service==0 && 'ไม่ระบุ'} 
                            {selectUserApply.user_type_service==1 && 'นิสิตคณะศึกษาศาสตร์'} 
                            {selectUserApply.user_type_service==2 && 'นิสิตมหาวิทยาลัยมหาสารคาม'} 
                            {selectUserApply.user_type_service==3 && 'บุคลากรมหาวิทยาลัยมหาสารคาม'} 
                            {selectUserApply.user_type_service==4 && 'บุคคลทั่วไป'} 
                            {selectUserApply.user_type_service==5 && 'อื่นๆ'} 
                         </Col> 
                </Row>

                <Row>  <Col> คะแนนความเครียด </Col>   
                        <Col> 
                            {selectUserApply.stressScore} 
                         </Col> 
                </Row>


                <Row>  <Col> ประเด็นปรึกษา </Col>   
                        <Col>  
                            {selectUserApply.issue_type == 0 && 'ไม่ระบุ'} 
                            {selectUserApply.issue_type == 1 && 'เครียด/วิตกกังวล'} 
                            {selectUserApply.issue_type == 2 && 'การเรียน'} 
                            {selectUserApply.issue_type == 3 && 'ซึมเศร้า/อาการทางจิตเวช'} 
                            {selectUserApply.issue_type == 4 && 'เพื่อน'} 
                            {selectUserApply.issue_type == 5 && 'ความรัก'} 
                            {selectUserApply.issue_type == 6 && 'การทำงาน"'} 
                            {selectUserApply.issue_type == 7 && 'การปรับตัว'} 
                            {selectUserApply.issue_type == 8 && 'ครอบครัว'} 
                            {selectUserApply.issue_type == 9 && 'คลินิก LD'} 
                            {selectUserApply.issue_type == 10 && 'อื่นๆ'} 
                        </Col> 
                         </Row>
                <Row>  <Col> รายละเอียดประเด็นการปรึกษา </Col>   
                        <Col>  
                            {selectUserApply.counselling_detail} 
                            </Col> 
                         </Row>
                <Row>
                 
                  <Col xs={12} md={12}>
                      วันและช่วงเวลาที่สะดวก
                 
                    <ScheduleSelector
                      selection={schedule}
                      startDate="2023-01-02"
                      numDays={5}
                      minTime={9}
                      maxTime={16}
                      hourlyChunks={1}
                      
                      renderDateLabel={(date) =>{
                        return <span>
                            {format(date,'d')==2 && 'จันทร์'}
                            {format(date,'d')==3 && 'อังคาร'}
                            {format(date,'d')==4 && 'พุธ'}
                            {format(date,'d')==5 && 'พฤหัส'}
                            {format(date,'d')==6 && 'ศุกร์'}
                          </span>}
                      }
                    />
                  </Col>
                </Row>
                <Row></Row>
                <Row>  <Col> ต้องการรับบริการแบบ</Col>   
                        <Col>  
                            {selectUserApply.counselling_type == 0 && 'ไม่ระบุ'} 
                            {selectUserApply.counselling_type == 1 && 'พบหน้า'} 
                            {selectUserApply.counselling_type == 2 && 'ออนไลน์'} 
                        </Col> 
                       </Row>
                <Row>  <Col> ต้องการพบผู้ให้การปรึกษาที่เป็น </Col>   
                        <Col>  
                            {selectUserApply.counsellor_type == 0 && 'ไม่ระบุ'} 
                            {selectUserApply.counsellor_type == 1 && 'อาจารย์'} 
                            {selectUserApply.counsellor_type == 2 && 'นิสิตจิตวิทยา'} 
                        </Col> 
                        </Row>
                <Row>  <Col> ต้องการพบผู้ให้การปรึกษาเพศ </Col>   
                        <Col>  
                            {selectUserApply.counsellor_gender == 0 && 'ไม่ระบุ'} 
                            {selectUserApply.counsellor_gender == 1 && 'ชาย'} 
                            {selectUserApply.counsellor_gender == 2 && 'หญิง'} 
                        </Col> 
                        </Row>
                <Row>  <Col> ข้อคิดเห็น ข้อมูลเพิ่มเติม ข้อสงสัย </Col>   
                        <Col>  {selectUserApply.remark} </Col> 
                        </Row>
                        
              </CardBody>
            </Card>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={isRoomEditModal}
        >
          <div className="modal-header justify-content-center">
            <button
              className="close"
              type="button"
              onClick={() => setIsRoomEditModal(false)}
            >
              <i className="now-ui-icons ui-1_simple-remove"></i>
            </button>
            <h3 className="title title-up">จัดการห้องให้การปรึกษา</h3>
          </div>
          <ModalBody>
            <RoomEdit
              isInit={isRoomInit}
              allUser={allUser}
              room={selectedRoomForEdit}
              
              onSuccess={(result) => _OnRoomEditChanged(result)}
            />
          </ModalBody>
        </Modal>
    </>
  );
}

export default ProfilePage;


export const columns = [
  {
    Header: () => (
      <div />
    ),
    accessor: 'name',
    maxWidth: 300,
    Cell: row => (
      <div className='first-column'>{row.value}</div>
    )
  }
];

export const subComponent = row => {
  return (
    <div>
      abcdefg
      {row.original.types.map((type, id) => {
        return (
          <div className='subRow' key={ id }>{ type.name }</div>
        );
      })}
    </div>
  );
};